import { CarrierEnum, ServiceEnum, LengthUnitEnum, WeightUnitEnum } from 'src/shared/enum';
import * as Yup from 'yup';

export interface IVolumetricWeightRequest {
    length: Number,
    width: Number,
    height: Number,
    dimensionUnit: LengthUnitEnum,
    carrier: CarrierEnum,
    service: ServiceEnum
}

export interface IVolumetricWeightResponse {
    volumetricWeight: Number,
    volumetricWeightUnit: WeightUnitEnum
}

export const GetVolumetricWeightFormInitialValues = () => {
	return {
        length: 0,
        width: 0,
        height: 0,
        carrier: CarrierEnum.Delhivery,
        service: ServiceEnum.Surface,
        dimensionUnit: LengthUnitEnum.CentiMeter
	};
};

export const GetVolumetricWeightFormValidationSchema = (t: any) => {
	return Yup.object().shape({
		length: Yup.number().required(t('label-required')).min(0.1).max(10000),
		width: Yup.number().required(t('label-required')).min(0.1).max(10000),
        height: Yup.number().required(t('label-required')).min(0.1).max(10000),
        carrier: Yup.string(),
        service: Yup.string()
	});
};
